import { Api } from "@/core/api.js";
const api = new Api();
import i18n from "@/i18n";

// initial state
const state = {
  list: [],
  contact_types: [],
  player_positions: [],
  alergies: []
};

// getters
const getters = {
  getList: (state, getters, rootState) => type => {
    var aPersons = [];
    for (var i in state.list) {
      if (
        typeof state.list[i].current_roles !== "undefined" &&
        typeof state.list[i].current_roles[0] !== "undefined"
      ) {
        state.list[i].contact_type =
          state.list[i].current_roles[0].contact_type;
        if (typeof state.list[i].current_roles[0] !== "undefined") {
          if (state.list[i].current_roles[0].club != null) {
            state.list[i].entity = state.list[i].current_roles[0].club;
            state.list[i].entity.type = "club";
          } else if (state.list[i].current_roles[0].hotel != null) {
            state.list[i].entity = state.list[i].current_roles[0].hotel;
            state.list[i].entity.type = "hotel";
          } else if (state.list[i].current_roles[0].facility != null) {
            state.list[i].entity = state.list[i].current_roles[0].facility;
            state.list[i].entity.type = "facility";
          } else if (state.list[i].current_roles[0].team != null) {
            state.list[i].entity = state.list[i].current_roles[0].team;
            state.list[i].entity.type = "team";
          } else if (state.list[i].current_roles[0].company != null) {
            state.list[i].entity = state.list[i].current_roles[0].company;
            state.list[i].entity.type = "company";
          } else if (state.list[i].current_roles[0].event != null) {
            state.list[i].entity = state.list[i].current_roles[0].event;
            state.list[i].entity.type = "event";
          }
        }
      } else {
        state.list[i].contact_type = { id: -1, name: i18n.t("not_role") };
        state.list[i].entity = { type: null };
      }

      if (state.list[i].visible) aPersons.push(state.list[i]);
    }
    return aPersons;
  },

  getListNoFiltered: (state, getters, rootState) => () => {
    var aPersons = [];
    for (var i in state.list) {
      aPersons.push(state.list[i]);
    }
    return aPersons;
  },

  get_by_id: (state, getters, rootState) => id => {
    if (typeof state.list[id] !== "undefined") {
      var person = Object.assign({}, state.list[id]);
      for (var k in person) {
        if (person[k] == "true") person[k] = true;
        else if (person[k] == "false") person[k] = false;
        // else if (parseInt(person[k]) == person[k])
        //   person[k] = parseInt(person[k]);
      }

      return person;
    }
    return false;
  },

  getContactTypes: (state, getters, rootState) => type => {
    if (typeof type === "undefined" || !type) {
      return ObjectToArray(state.contact_types);
    } else {
      var aContactTypes = [];
      for (var key in state.contact_types) {
        var contact_type = state.contact_types[key];
        if (parseInt(contact_type.type) == type) {
          aContactTypes.push(contact_type);
        }
      }

      return aContactTypes;
    }
  },

  getContactTypeById: (state, getters, rootState) => id => {
    var contact_type = {};
    for (var k in state.contact_types) {
      if (id == k) {
        contact_type = state.contact_types[k];
      }
    }

    return contact_type;
  },

  getGlobalTypes: (state, getters, rootState) => () => {
    return [
      { id: 1, name: "persons.competition" },
      { id: 2, name: "persons.partners" },
      { id: 3, name: "persons.logistic" },
      { id: 4, name: "persons.leads" }
    ];
  },

  getPositions: (state, getters, rootState) => () => {
    return state.player_positions;
  },

  getPosition: (state, getters, rootState) => id => {
    return state.player_positions[id];
  },

  getAlergies: (state, getters, rootState) => () => {
    return state.alergies;
  },

  getGenders: (state, getters, rootState) => () => {
    return [
      { name: "gender.male", id: 1 },
      { name: "gender.female", id: 2 },
      { name: "gender.other", id: 3 }
    ];
  }
};

// actions
const actions = {
  search(content, params) {
    return api.post("person/search", params).then(function(response) {
      if (response.status) {
        var data = response.data;
        return data;
      }
      return false;
    });
  },

  getVolunteer: (context, params) => {
    return api
      .post("volunteer/" + params.person_id, { volunteer: 1 })
      .then(function(response) {
        if (response.status) {
          return context.commit("addPerson", response.data);
        } else {
          return false;
        }
      });
  },

  addVolunteer: ({ commit }, params) => {
    var document = { ...params };
    let form = new FormData();
    Object.entries(document.files).forEach(([key, value]) => {
      form.append(key, document.files[key]);
    });

    for (var i in params) {
      form.append(i, params[i]);
    }
    return api.import("volunteer/add", form, params).then(function(response) {
      if (response.status) {
        return response.data;
      } else {
        return false;
      }
    });
  },

  editVolunteer: ({ commit }, params) => {
    console.log("-- editVolunteer --", params);
    var document = { ...params.data };
    let form = new FormData();
    Object.entries(document.files).forEach(([key, value]) => {
      form.append(key, document.files[key]);
    });

    for (var i in params.data) {
      form.append(i, params.data[i]);
    }
    console.log(form, params.data);
    return api
      .import("volunteer/" + params.id + "/edit", form, params.data)
      .then(function(response) {
        if (response.status) {
          return response.data;
        } else {
          return false;
        }
      });
  },

  upload(context, data) {
    var document = { ...data };
    let form = new FormData();
    Object.entries(document.files).forEach(([key, value]) => {
      form.append(key, document.files[key]);
    });
    form.append("name", document.name);

    var path = "volunteer/document/add";
    return api.import(path, form).then(function(response) {
      if (response.status) {
        // context.dispatch('loadList', document.event).then(function () { });
        return true;
      } else {
        return false;
      }
    });
  },

  addRelationToEvent(context, params) {
    return api
      .post(
        "volunteer/" + params.id + "/event/" + params.event_id + "/edit",
        params
      )
      .then(function(response) {
        if (response.status) {
          return response.data;
        } else {
          return false;
        }
      });
  }
};

// mutations
const mutations = {
  setList(state, data) {
    state.list = data;
  },

  addPerson(state, person) {
    var list = { ...state.list };
    list[person.id] = person;

    state.list = list;
  },

  removePerson(state, id) {
    var list = { ...state.list };
    delete list[id];

    state.list = list;
  },

  addNote(state, { id, note }) {
    var list = { ...state.list };
    list[id].notes[note.id] = note;

    state.list = list;
  },

  removeNote(state, { id, note }) {
    var list = { ...state.list };
    delete list[id].notes[note];

    state.list = list;
  },

  applyFilters(state, filters) {
    var list = { ...state.list };
    if (!filters) {
      for (var i in list) {
        list[i].visible = true;
      }
    } else {
      for (var i in list) {
        list[i].visible = false;
      }
      for (var i in list) {
        var item = list[i];
        var bFound = true;
        for (var k in filters) {
          // var item_value = ( item[k] != null && typeof item[k] == 'object' )? item[k].id : item[k];
          // var regexp = new RegExp( filters[k].trim(), "gi" );
          // if( item.hasOwnProperty( k ) && typeof item[k] == 'object' && filters[ k ] != item_value ) {
          //   bFound = false;
          // }
          // else if( item.hasOwnProperty( k ) && typeof item[k] !== 'object' && !item_value.match( regexp ) ){
          //     bFound = false;
          // }
          if (filters[k] != -1) {
            var item_value =
              item[k] != null && typeof item[k] == "object"
                ? item[k].id
                : item[k];
            if (
              item.hasOwnProperty(k) &&
              filters[k] == null &&
              item_value == null
            ) {
            } else {
              // filters[k] = filters[k] == null ? null : ( typeof filters[k] !== 'string' ? ( typeof filters[k] !== 'boolean' ? ( filters[k] ? 1 : 0 ) : filters[k] ) : filters[k].trim() )

              if (filters[k] != null && typeof filters[k] === "boolean")
                filters[k] = filters[k] ? 1 : 0;
              else if (filters[k] != null && typeof filters[k] === "string")
                filters[k] = filters[k].trim();

              var regexp = new RegExp(filters[k], "gi");

              if (
                item.hasOwnProperty(k) &&
                typeof item[k] == "object" &&
                filters[k] != item_value
              ) {
                bFound = false;
              } else if (
                item.hasOwnProperty(k) &&
                typeof item[k] !== "object" &&
                !item_value.match(regexp)
              ) {
                bFound = false;
              }
            }
          }
        }

        list[i].visible = bFound;
      }
    }

    state.list = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
